import { useMutation, useQuery } from '@tanstack/react-query';
import { onboardApi, type CompleteBody } from '@/api/onboard.api';

export const onboardKeys = {
  all: ['onboard'] as const,
  invitation: (token: string) => [...onboardKeys.all, 'invitation', token] as const,
  waQr: (token: string) => [...onboardKeys.all, 'wa-qr', token] as const,
  waStatus: (token: string) => [...onboardKeys.all, 'wa-status', token] as const,
};

export function useOnboardInvitation(token: string) {
  return useQuery({
    queryKey: onboardKeys.invitation(token),
    queryFn: () => onboardApi.validate(token),
    retry: false, // 400 = invitación inválida/expirada: no reintentar
  });
}

export function useWaStart(token: string) {
  return useMutation({
    mutationFn: () => onboardApi.waStart(token),
  });
}

export function useWaQr(token: string, enabled: boolean) {
  return useQuery({
    queryKey: onboardKeys.waQr(token),
    queryFn: () => onboardApi.waQr(token),
    enabled,
    refetchInterval: enabled ? 3000 : false,
  });
}

export function useWaStatus(token: string, enabled: boolean) {
  return useQuery({
    queryKey: onboardKeys.waStatus(token),
    queryFn: () => onboardApi.waStatus(token),
    enabled,
    // Deja de pollear cuando conecta ('open').
    refetchInterval: (query) => (enabled && query.state.data?.status !== 'open' ? 3000 : false),
  });
}

export function useCompleteOnboard(token: string) {
  return useMutation({
    mutationFn: (body: CompleteBody) => onboardApi.complete(token, body),
  });
}
